import * as React from 'react';
import { Button } from '@common/bw-ui/ui/button';
import { cn } from '@common/bw-ui/lib/utils';

export interface AuthPromptProps {
  signInHref: string;
  createAccountHref?: string;
  className?: string;
}

export function AuthPrompt({
  signInHref,
  createAccountHref,
  className,
}: AuthPromptProps) {
  return (
    <div
      className={cn(
        'tw:flex tw:flex-col tw:gap-4 tw:rounded-lg tw:bg-white tw:p-4 tw:md:p-6 tw:shadow-md',
        className,
      )}
    >
      <Button size="xl" asChild>
        <a href={signInHref}>Sign in</a>
      </Button>
      {createAccountHref && (
        <Button variant="outline-primary" size="xl" asChild>
          <a href={createAccountHref}>Create an account</a>
        </Button>
      )}
    </div>
  );
}
